import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext({});

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("axtreme_cart") || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem("axtreme_cart", JSON.stringify(items)); }, [items]);

  const add = useCallback((product, qty = 1) => {
    setItems(prev => {
      const i = prev.findIndex(p => p.slug === product.slug);
      if (i >= 0) { const n = [...prev]; n[i] = { ...n[i], qty: n[i].qty + qty }; return n; }
      return [...prev, { slug: product.slug, name: product.name, price: product.price, image: product.image, qty }];
    });
  }, []);
  const remove = useCallback((slug) => setItems(prev => prev.filter(p => p.slug !== slug)), []);
  const setQty = useCallback((slug, qty) => setItems(prev => prev.map(p => p.slug === slug ? { ...p, qty: Math.max(1, qty) } : p)), []);
  const clear = useCallback(() => setItems([]), []);

  const total = useMemo(() => items.reduce((s, i) => s + i.price * i.qty, 0), [items]);
  const count = useMemo(() => items.reduce((s, i) => s + i.qty, 0), [items]);

  const value = useMemo(
    () => ({ items, add, remove, setQty, clear, total, count }),
    [items, add, remove, setQty, clear, total, count]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
